function findActionIndex(actions, action) {
  let start = 0
  let end = actions.length - 1
  while (start <= end) {
    let mid = Math.floor((start + end) / 2)
    if (actions[mid].delay < action.delay) {
      start = mid + 1
    } else if (actions[mid].delay > action.delay) {
      end = mid - 1
    } else {
      return mid
    }
  }
  return start
}

export default class Timer {
  constructor(actions, speed) {
    this.timeOffset = 0
    this.raf = null
    this.actions = actions
    this._actions = actions.slice()
    this.speed = speed
  }
  addAction(action) {
    const index = findActionIndex(this.actions, action)
    this.actions.splice(index, 0, action)
    this._actions.splice(index, 0, action)
  }
  addActions(actions) {
    const addedActions = this.actions.concat(actions)
    this.actions = addedActions
    this._actions = addedActions.slice()
  }
  start(timeOffset = 0) {
    console.log('start', timeOffset)
    this.actions.sort((a1, a2) => a1.delay - a2.delay)
    this.timeOffset = timeOffset
    let lastTimestamp = performance.now()
    const actions = this.actions
    const self = this
    function check() {
      const time = performance.now()
      self.timeOffset += (time - lastTimestamp) * self.speed
      lastTimestamp = time
      while (actions.length) {
        const action = actions[0]
        if (self.timeOffset >= action.delay) {
          actions.shift()
          action.doAction()
        } else {
          break
        }
      }
      if (actions.length > 0) {
        self.raf = requestAnimationFrame(check)
      } else {
        console.log('done')
      }
    }
    this.raf = requestAnimationFrame(check)
  }
  reset() {
    this.timeOffset = 0
    this.actions = this._actions.slice()
    this.stop()
  }
  play(timeOffset) {
    if (!timeOffset) {
      timeOffset = this.timeOffset
      console.log('timeOffset', timeOffset)
    } else {
      const actions = this._actions.filter(item => item.delay >= timeOffset)
      if (!actions.length) return
      this.actions = actions
    }
    this.start(timeOffset)
  }
  update(timeOffset) {
    const actions = this.actions
    while (actions.length) {
      const action = actions[0]
      if (timeOffset >= action.delay) {
        actions.shift()
        action.doAction()
      } else {
        break
      }
    }
  }
  stop() {
    if (this.raf) {
      cancelAnimationFrame(this.raf)
      this.raf = null
    }
  }
  setTime(timeOffset) {
    this.timeOffset = timeOffset
  }
  setSpeed(speed) {
    this.speed = speed
  }
  clear() {
    this.stop()
    this.actions.length = 0
    this._actions.length = 0
  }
}
